import { environment } from 'src/environments/environment';

export const slidersData = [
  {
    title: 'Continue Watching',
    isActive: false,
    activeIndex: null,
    slides: [
      {
        name: 'Discovery',
        platform: 'Paramount',
        rating: '98%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-1.jpg`,
        active: false,
      },
      {
        name: 'The Boys',
        platform: 'Prime Video',
        rating: '91%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-2.jpg`,
        active: false,
      },
      {
        name: 'Only Murders in the Building',
        platform: 'Hulu',
        rating: '100%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-3.jpg`,
        active: false,
      },
      {
        name: 'The Marvelous Mrs. Maisel',
        platform: 'Prime Video',
        rating: '85%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-4.jpg`,
        active: false,
      },
      {
        name: 'Succession',
        platform: 'HBO Max',
        rating: '82%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-5.jpg`,
        active: false,
      },
      {
        name: 'Shang-Chi and the Legend of ...',
        platform: 'Disney+',
        rating: '91%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide1/movie-tile-6.jpg`,
        active: false,
      },
    ],
  },
  {
    title: 'Action',
    isActive: false,
    activeIndex: null,
    slides: [
      {
        name: 'F9 The Fast Saga',
        platform: 'Paramount',
        rating: '59%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-1.jpg`,
        active: false,
      },
      {
        name: 'Dune',
        platform: 'HBO Max',
        rating: '83%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-2.jpg`,
        active: false,
      },
      {
        name: 'Wonder Woman 1984',
        platform: 'HBO Max',
        rating: '58%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-3.jpg`,
        active: false,
      },
      {
        name: 'Venom: Let There Be Carnage',
        platform: 'Prime Video',
        rating: '59%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-4.jpg`,
        active: false,
      },
      {
        name: 'The Wheel Of Time',
        platform: 'HBO Max',
        rating: '59%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-5.jpg`,
        active: false,
      },
      {
        name: 'Snake Eyes',
        platform: 'EPIX NOW',
        rating: '35%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide2/movie-tile-6.jpg`,
        active: false,
      },
    ],
  },
  {
    title: 'Trending on Google',
    isActive: false,
    activeIndex: null,
    slides: [
      {
        name: 'The Resident',
        platform: 'Prime Video',
        rating: '91%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-1.jpg`,
        active: false,
      },
      {
        name: 'Spontaneous',
        platform: 'EPIX NOW',
        rating: '97%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-2.jpg`,
        active: false,
      },
      {
        name: 'Fear the Walking Dead',
        platform: 'Pluto TV',
        rating: '75%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-3.jpg`,
        active: false,
      },
      {
        name: 'This Is Us',
        platform: 'Peacock TV',
        rating: '95%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-4.jpg`,
        active: false,
      },
      {
        name: 'Bel-Air',
        platform: 'Peacock TV',
        rating: '67%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-5.jpg`,
        active: false,
      },
      {
        name: 'Free Guy',
        platform: 'HBO Max',
        rating: '80%',
        src: `${environment.baseHref}/assets/images/browse-titles-page/slide3/movie-tile-6.jpg`,
        active: false,
      },
    ],
  },
];
